import axios from 'axios';
import authHeader from './authHeader';

const API_URL = '/api/audit';

export function fetchAudit({ entityType, limit = 100 } = {}) {
  const params = new URLSearchParams();
  if (entityType) params.append('entity_type', entityType);
  if (limit) params.append('limit', String(limit));
  return axios.get(`${API_URL}?${params.toString()}`, { headers: authHeader() });
}

export function fetchCommandQueue({ status = 'all', limit = 200 } = {}) {
  const params = new URLSearchParams();
  params.append('status', status);
  params.append('limit', String(limit));
  return axios.get(`${API_URL}/command-queue?${params.toString()}`, { headers: authHeader() });
}

const logsService = { fetchAudit, fetchCommandQueue };
export default logsService;
